import * as Yup from 'yup';
import { EMAIL_REGEX, isValidMobileNumber, extractNationalNumber } from 'utils';

const registrationSchema = (
  t,
  { canCreateUnverifiedWorkers, emailConstraints, mobilePhoneNumberConstraints, emailOrMobilePhoneNumberConstraints },
) =>
  Yup.object({
    email: Yup.string()
      .matches(EMAIL_REGEX, {
        message: t('workerRegistration.errors.invalidEmail'),
        excludeEmptyString: true,
      })
      .test('email-required', t('workerRegistration.errors.emailRequired'), function (value) {
        const { mobilePhoneNumber } = this.parent;
        const nationalNumber = extractNationalNumber(mobilePhoneNumber);
        const hasPhoneAttempt = nationalNumber && nationalNumber.trim() !== '';
        const hasEmail = value?.trim();

        const isEmailRequired =
          (emailConstraints?.isMandatory ||
            (emailOrMobilePhoneNumberConstraints?.isMandatory &&
              !mobilePhoneNumberConstraints?.isMandatory &&
              !hasPhoneAttempt) ||
            (!canCreateUnverifiedWorkers && !mobilePhoneNumberConstraints?.isMandatory && !hasPhoneAttempt)) &&
          (emailConstraints.isVisible || emailOrMobilePhoneNumberConstraints.isVisible);

        if (isEmailRequired && !hasEmail) {
          return false;
        }
        return true;
      }),
    mobilePhoneNumber: Yup.string()
      .trim()
      .test('phone-required', t('workerRegistration.errors.phoneNumberRequired'), function (value) {
        const { email } = this.parent;
        const nationalNumber = extractNationalNumber(value);
        const hasPhoneAttempt = nationalNumber && nationalNumber.trim() !== '';
        const hasEmail = email?.trim();

        const isPhoneRequired =
          mobilePhoneNumberConstraints.isMandatory ||
          (emailOrMobilePhoneNumberConstraints.isMandatory && !emailConstraints?.isMandatory && !hasEmail) ||
          (!canCreateUnverifiedWorkers &&
            !emailConstraints?.isMandatory &&
            !hasEmail &&
            (mobilePhoneNumberConstraints.isVisible || emailOrMobilePhoneNumberConstraints.isVisible));

        if (isPhoneRequired && !hasPhoneAttempt) {
          return false;
        }
        return true;
      })
      .test('mobilePhoneNumber-valid', t('workerRegistration.errors.invalidPhoneNumber'), function (value) {
        const nationalNumber = extractNationalNumber(value);
        if (!nationalNumber || nationalNumber.trim() === '') {
          return true;
        }
        return isValidMobileNumber(value);
      }),
  });

export default registrationSchema;
